module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0136.jpg?v=d7c03b29";